import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);
  console.log("RTWalls useActionTable");
  const refreshTable = () => {
    console.log("refreshTable");
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    console.log("Isrefetched render");
    getStructureData("structure.walls.walls");
  }, [isRefetched]);

  // useEffect(() => {
  //   console.log(action.parameters?.impact?.walls);
  //   filteringData(action.parameters?.impact?.walls);
  // }, [action.parameters?.impact?.walls]);

  function filteringData(data) {
    console.log("filteringData");
    const allowed = [
      "name",
      "uuid",
      "id",
      "surface",
      "materials",
      "thermicalresistance",
      "deperditionpart",
      "uwall",
      "isSelected",
    ];
    const allowedMaterials = ["name", "uuid", "id"];

    const filteredData = [];
    data.map((wall) => {
      const filteredObj = _.pick(wall, allowed);
      filteredData.push(filteredObj);
    });

    const newKeys = { uuid: "id" };

    const replacedUuidWithIdName = [];

    filteredData.map((wall) => {
      const renamedObj = renameKeys(wall, newKeys);
      replacedUuidWithIdName.push(renamedObj);   
    });
    const replacedMaterials = replacedUuidWithIdName.map((wall) => {
      let materials = wall.materials.map((material) => {
        let filteredObj = _.pick(material, allowedMaterials);
        return filteredObj;
      });
      return {
        name: wall.name,
        id: wall.id,
        surface: wall.surface,
        thermicalresistance: wall.thermicalresistance,
        deperditionpart: wall.deperditionpart,
        uwall: wall.uwall,
        isSelected: wall.isSelected,
        materials,
      };
    });

    console.log(filteredData, replacedMaterials);

    setStructureData(replacedMaterials);
  }

  const getStructureData = async (route) => {
    console.log("getStructureData");
    let data = [];
    let walls = action.parameters?.impact?.walls || [];
    let selectedwalls = [];
    let wallsIds = walls.map((wall) => {
      selectedwalls.push(wall.id);
      return wall.id;
    });
    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.structure?.walls?.walls || [];
      });
    if (walls.length !== 0 || data.length !== 0) {
      filteringData([
        ...data.filter((obj) => !wallsIds.includes(obj.uuid)),
        ...walls,
      ]);
    }
  };

  function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  const headerComponentMemo = useMemo(() => {
    console.log("headerComponentMemo");
    return (
      <>
        <TableName>Selection des parois</TableName>
      </>
    );
  }, []);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      title: headerComponentMemo,
      //subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
  };
}
